<template>
  <div id="import-dialog" v-if="isShowDocImport">
    <div class="">
      <el-dialog
        v-loading="loading"
        :visible.sync="isShowDocImport"
        top="30vh"
        :center="false"
        width="360px"
        style="border-radius:15px;"
        :close-on-click-modal="true"
        :append-to-body="true"
        @close="close"
      >
        <div slot="title" class="title">文件导入</div>
        <div class="import-doc-box">
          <el-upload
            class="avatar-uploader"
            :action="action"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="beforeAvatarUpload"
          >
            <div class="import-doc">请选择导入文章的文件</div>
          </el-upload>
        </div>
        <div class="explain">
          <p>
            1、文件导入目前支持格式：.txt,.doc,.docx(单个文件不超过20M)
          </p>
          <p>2、链接导入支持微信、知乎专栏</p>
          <p>3、导入文章后自行检查文章的完整性和排版</p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import editorControl from "../../assets/script/utils/editorControl";
import config from "../../assets/script/config";
export default {
  data() {
    return {
      link: "",
      isShowDocImport: true,
      loading: false,
      fileList: [],
      textData: null,
      action: config.importFileUrl
    };
  },
  computed: {},
  watch: {},
  mounted() {},

  methods: {
    ...mapActions("api", ["ALink"]),
    //导入链接
    handleAvatarSuccess(res) {
      this.loading = false;
      if (res.errorCode == 0) {
        editorControl.setAllInnerNoDataTxt(res.data, "导入文章成功");
        this.$emit("closeShowDocImport");
      } else {
        this.$message({
          showClose: true,
          message: "导入文章失败",
          type: "error"
        });
        return;
      }
    },
    beforeAvatarUpload(file) {
      const isLt20M = file.size / 1024 / 1024 < 20;

      if (!isLt20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      this.loading = true;
      return isLt20M;
    },
    close() {
      this.$emit("closeShowDocImport");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.link-box {
  display: flex;
  width: 310px;
  .link-button {
    padding: 12px 15px;
    background-color: @blue;
    color: white;
    border-radius: 0 20px 20px 0;
    border: none;
    border-left: none;
  }
  .import-link-input /deep/.el-input__inner {
    border-radius: 20px 0 0 20px;
    border-right: none;
  }
}
//说明
.explain {
  margin-top: 10px;
  p {
    font-size: @font-size12;
    color: @color999;
    line-height: 2em;
  }
}

/deep/.el-dialog__header {
  padding: 10px !important;
  border-bottom: 1px solid #f4f4f4;
}

/deep/.el-dialog__headerbtn {
  top: 14px;
}
.import-doc {
  background-color: @blue;
  color: white;
  line-height: 40px;
  padding: 0 10px;
  margin: 0 auto;
  width: 320px;
  border-radius: 205px;
}
</style>
<style lang="less">
// .search-box .el-input__inner {
//   height: 24px;
//   line-height: 24px;

//   background-color: #568af8;
//   color: white;
//   border: none;
//   border-radius: 15px 0 0 15px;
// }
// .search-box .el-input__inner::placeholder {
//   color: #eaecfb;
// }
// .search-box .el-input--mini .el-input__icon {
//   color: #eaecfb;
// }
</style>
